import {
  createContext,
  ReactNode,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
import { Promotion } from "../@data/promotion";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { firestore } from "../services/firebase";

export interface PromotionsContextModel {
  promotions: Promotion[];
  loadingPromotions: boolean;
}

export const PromotionsContext = createContext<PromotionsContextModel>(
  {} as PromotionsContextModel
);

export const PromotionsProvider = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => {
  const [promotions, setPromotions] = useState<Promotion[]>([] as Promotion[]);
  const [loadingPromotions, setLoadingPromotions] = useState<boolean>(true);

  const handleGetPromotions = useCallback(async () => {
    const q = query(
      collection(firestore, "promotions"),
      orderBy("flashPromotion", "desc")
    );
    getDocs(q)
      .then((snapshot) => {
        let promotionsData = [] as Promotion[];
        snapshot.forEach((promotion) =>
          promotionsData.push({
            ...(promotion.data() as Promotion),
            promotionId: promotion.id,
          })
        );
        setPromotions(promotionsData);
      })
      .finally(() => setLoadingPromotions(false));
  }, []);

  useEffect(() => {
    handleGetPromotions();
  }, [handleGetPromotions]);

  return (
    <PromotionsContext.Provider
      value={{
        promotions,
        loadingPromotions,
      }}
    >
      {children}
    </PromotionsContext.Provider>
  );
};

export const usePromotions = () => useContext(PromotionsContext);
